import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-8">
          <div className="flex items-center gap-2 mb-1">
            <div className="w-7 h-7 flex items-center justify-center">
              <i className="ri-chat-3-line text-xl text-primary-600"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              吃瓜评论
            </h2>
          </div>
          <p className="text-sm text-foreground-500">千万吃瓜群众的热议与讨论</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{comment.name}</p>
                  <p className="text-xs text-foreground-400 whitespace-nowrap">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
              <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-200/50">
                <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-thumb-up-line"></i>
                  <span>{comment.likes.toLocaleString()}</span>
                </button>
                <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-chat-1-line"></i>
                  <span>回复</span>
                </button>
                <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-share-forward-line"></i>
                  <span>分享</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}